// extracted by mini-css-extract-plugin
module.exports = {"everyBodyBlue":"#00b5de","chartWrapper":"style__chartWrapper__yPyfP","tick":"style__tick__wuAwJ","month":"style__month__H-zVY","tooltip":"style__tooltip__dfzK0"};